// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Import Tailwind styles here
import App from "./App";
import 'react-toastify/dist/ReactToastify.css';   // ← Add this line
import { MunicipalityProvider } from "./components/MunicipalityContext";
import { ConnectionProvider } from "./components/ConnectionContext";

ReactDOM.createRoot(document.getElementById("root")!).render(
   <React.StrictMode>
   <ConnectionProvider>
   <MunicipalityProvider>
    <App />
   </MunicipalityProvider>
   </ConnectionProvider>
   </React.StrictMode> 
);
